import { cloneElement, createContext, useContext, useState } from "react";
import { ViewerButton } from "./ViewerControls";

const SlideContext = createContext(null);

export const ViewerSlide = ({ slide, children }) => {
    const [attempt, setAttempt] = useState(0);
    return (
        <SlideContext.Provider value={{ slide, retry: () => setAttempt((value) => value + 1) }}>
            {cloneElement(children, { key: attempt })}
        </SlideContext.Provider>
    );
};

export const ViewerStatus = ({ error = false }) => {
    const { slide, retry } = useContext(SlideContext);
    return (
        <div className="viewer-status" role={error ? "alert" : "status"}
            data-testid={`image-viewer-${error ? "error" : "loading"}-${slide.viewerId}`}>
            <p>{error ? "Immagine non disponibile." : "Caricamento…"}</p>
            {error && <ViewerButton name={`retry-${slide.viewerId}`} label="Riprova a caricare l’immagine"
                className="viewer-retry" onClick={(event) => { event.stopPropagation(); retry(); }}>Riprova</ViewerButton>}
        </div>
    );
};